import React from 'react'
import SvgIcon from 'react-native-svg-icon'
import icons from './icons'
const MSFESSvgIcon = (props) => {

return <SvgIcon {...props} svgs={icons} />

}

export default MSFESSvgIcon